import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { IntlProvider } from 'react-intl';
import Routes from './routes';
import { actions as localeActions } from './redux/ducks/locale';
import { actions as loginActions } from './redux/ducks/login';
import { actions as changePasswordActions } from './redux/ducks/change-password';
import { actions as tcActions } from './redux/ducks/terms-and-conditions';
import { getLocale } from './util/locale';

export const App = (props) => {
  const getLocale = (locale) => {
    switch (locale) {
      case 'en_GB':
      case 'en_CA':
        return 'en_US';
      case 'es_US':
      case 'es_ES':
        return 'es_AR';
      case 'in_ID':
        return 'id_ID';
      case 'it_CH':
        return 'it_IT';
      case 'ro_MO':
        return 'ro_RO';
      default:
        return locale;
    }
  };
  const { history, locale, rightToLeftLangCodes } = props;

  const [messages, setMessages] = useState({});

  useEffect(() => {
    const localeLabel = getLocale(locale);

    const loadLocale = async () => {
      try {
        const localeModule = await import(
          /* webpackMode: "lazy" */
          `../locales/labels_${localeLabel}.json`
        );
        setMessages(localeModule.default || localeModule);
      } catch (error) {
        console.warn(`Locale ${localeLabel} not found, falling back to en_US`);
        const fallbackModule = await import(
          /* webpackMode: "lazy" */
          '../locales/labels_en_US.json'
        );
        setMessages(fallbackModule.default || fallbackModule);
      }
    };

    loadLocale();

    if (rightToLeftLangCodes && 
      rightToLeftLangCodes.length > 0 && 
      rightToLeftLangCodes.includes(locale)) {
      document.getElementsByTagName('html')[0].setAttribute("dir", 'rtl');
    } else {
      document.getElementsByTagName('html')[0].setAttribute("dir", 'ltr');
    }
  }, [locale, rightToLeftLangCodes]);

  const intlLocale = (locale || 'en_US').replace(/_/g, '-');

  return (
    <IntlProvider
      locale={ intlLocale }
      defaultLocale="en-US"
      messages={ messages }
    >
      <Router history={ history }>
        <Routes { ...props } />
      </Router>
    </IntlProvider>
  );
};

App.propTypes = {
  history: PropTypes.objectOf(PropTypes.any),
  locale: PropTypes.string,
};

const mapStateToProps = ({
  locale,
  login,
  brand,
  signin,
  sendingRequest,
  changepassword,
  termsandconditions,
}) => ({
  ...locale,
  ...login,
  ...brand,
  ...signin,
  ...sendingRequest,
  ...changepassword,
  ...termsandconditions,
});

const mapDispatchToProps = dispatch => bindActionCreators(
    Object.assign(
      {},
      { ...localeActions },
      { ...loginActions },
      { ...changePasswordActions },
      { ...tcActions },
    ),
    dispatch,
  );
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(App);
